module.exports = __webpack_public_path__ + "img/supply-chain-b.2a6511a2.svg";